import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
export const TASK_OPERATION_TIMEOUT_MS = getQueryTimeoutMs({
    productionMs: 3000,
});
//# sourceMappingURL=constants.js.map